/**
 * Quick-filter key constants — each maps to a predicate applied in AllProductsPage.
 * Exported from constants/ so page files and panel components import from a stable location
 * rather than creating a cross-page dependency (DIP).
 */
export const QUICK_FILTERS = Object.freeze({
    ALL_DRAFTS: 'all_drafts',
    MY_DRAFTS: 'my_drafts',
    MY_UNDER_REVIEW: 'my_under_review',
    MY_APPROVED: 'my_approved',
    // Org-wide (no personal/author filter) — grouped under All Products.
    PITCHES: 'pitches',
    FINTEL: 'fintel',
    SITREP: 'sitrep',
    DISCLOSURES: 'disclosures',
    ALL_PUBLISHED: 'all_published',
});

export const QUICK_FILTER_LABELS = {
    [QUICK_FILTERS.ALL_DRAFTS]: 'Drafts',
    [QUICK_FILTERS.MY_DRAFTS]: 'My Drafts',
    [QUICK_FILTERS.MY_UNDER_REVIEW]: 'Under Review',
    [QUICK_FILTERS.MY_APPROVED]: 'Approved / Published',
    [QUICK_FILTERS.PITCHES]: 'Pitches',
    [QUICK_FILTERS.FINTEL]: 'FINTEL',
    [QUICK_FILTERS.SITREP]: 'SITREP',
    [QUICK_FILTERS.DISCLOSURES]: 'Disclosures',
    [QUICK_FILTERS.ALL_PUBLISHED]: 'All Published Products',
};

/** Product-type label used to distinguish disclosures from analytic/FINTEL products. */
export const DISCLOSURE_PRODUCT_TYPE_LABEL = 'Disclosure';

/** Product-type label for pitch products. */
export const PITCH_PRODUCT_TYPE_LABEL = 'Pitch';

/**
 * Product-type label for IIRs. IIRs are (almost) raw collection data, not
 * Intelligence Products — they are excluded from the products page entirely
 * (P10 / MINSKY-16308) and live under /collection/iir instead.
 */
export const IIR_PRODUCT_TYPE_LABEL = 'IIR';
